import { Button, ButtonProps } from "@faire/web--source/slate/Button";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

type IProps = ButtonProps & {
  visibleWhen?: boolean;
};

export const ShowMoreOrdersButton: React.FC<IProps> = ({
  visibleWhen,
  ...props
}) => {
  if (visibleWhen === false) {
    return null;
  }

  return (
    <ResponsiveButton variant="tertiary" {...props}>
      <StrictLocalMsg
        defaultMessage="Show more orders"
        description={{
          text: "CTA button to show more orders in the page",
        }}
      />
    </ResponsiveButton>
  );
};

const ResponsiveButton = styled(Button)`
  ${responsiveMediaQueries.mobile} {
    width: 100%;
  }
`;
